import { ALDINE, ALIKE, SWISS_BLACK, SWISS_BOLD } from '../constants/type'

import { css } from 'styled-components/macro'

// Swiss-Black

// Swiss-Bold

//AbrilFatface-Regular
import AldineTtf from '../fonts/Aldine-721-BT.ttf'
import AldineWoff from '../fonts/Aldine-721-BT.woff'
import AldineWoff2 from '../fonts/Aldine-721-BT.woff2'

//Swiss Bold
import SwissBoldWoff from '../fonts/Swiss721BT-BoldCondensed.woff'
import SwissBoldWoff2 from '../fonts/Swiss721BT-BoldCondensed.woff2'

//Swiss Bold
import SwissBlackWoff from '../fonts/Swiss721BT-BlackCondensed.woff'
import SwissBlackWoff2 from '../fonts/Swiss721BT-BlackCondensed.woff2'

//Alike-Regular
import AlikeEot from '../fonts/Alike.eot'
import AlikeTtf from '../fonts/Alike.ttf'
import AlikeWoff from '../fonts/Alike.woff'
import AlikeWoff2 from '../fonts/Alike.woff2'

export default () => css`
  @font-face {
    font-family: ${ALDINE};
    src: url('${AldineWoff}') format('woff'),
       url('${AldineWoff2}') format('woff2'),
       url('${AldineTtf}')  format('truetype');
  }

  @font-face {
    font-family: ${SWISS_BOLD};
    src: url('${SwissBoldWoff2}') format('woff2'),
       url('${SwissBoldWoff}')  format('woff');
    font-style: normal;
    font-weight: 700;
  }
  @font-face {
    font-family: ${SWISS_BLACK};
    src: url('${SwissBlackWoff2}') format('woff2'),
    url('${SwissBlackWoff}')  format('woff');
    font-style: normal;
    font-weight: normal;
  }

  @font-face {
    font-family: ${ALIKE};
    src: url('${AlikeEot}');
    src: url('${AlikeEot}#iefix') format('embedded-opentype'),
       url('${AlikeWoff}') format('woff'),
       url('${AlikeWoff2}') format('woff2'),
       url('${AlikeTtf}')  format('truetype');
    font-style: normal;
    font-weight: normal;
  }
`
